import { css } from 'linaria';
import { containerMaxWidth } from 'common/constants';
import { breakpointTinyTablet } from 'common/constants';
import { breakpointLargeHandset } from 'common/constants';
const sectionWrapperStyle = "saqrz8k";
export const SectionWrapper = ({
  children,
  className = '',
  ...rest
}) => {
  return <div className={`${sectionWrapperStyle} ${className}`} {...rest}>
      <div className="inner">{children}</div>
    </div>;
};

require("./section-wrapper.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./section-wrapper.js");